import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: 'mdi',
    },
    theme: {
        themes: {
            light: {
                primary: '#555555',
                secondary: '#F6F6F6',
                accent: '#FBD020',
                error: '#B71C1C'
            }
        }
    },
});
